import { ReactNode } from "react"
import { TableCell } from "@mui/material"
import classNames from "classnames"

export interface ExtraActionsProps {
   isDisabled: boolean
   extraActions: ReactNode
}

export function ExtraActions({ isDisabled, extraActions }: ExtraActionsProps) {
   return (
      <TableCell
         className="table__cell table__cell--actions"
         align="right"
      >
         <div
            className={classNames("table__actions", {
               "table__actions--disabled": isDisabled,
            })}
         >
            {extraActions}
         </div>
      </TableCell>
   )
}
